import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup,FormControl, Validators } from '@angular/forms';
import {Router, ActivatedRoute } from "@angular/router";
import { UsersService } from '../../services/users.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import getMAC, { isMAC } from 'getmac'
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent implements OnInit {

  submitted = false; closeResult = '';
  errorInfo:{isError:boolean,errorMsg:string} = {isError:false,errorMsg:''}
  data={};
  constructor(private http: HttpClient,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    public auth: UsersService,
    private modalService: NgbModal,
  ) { 
    
  }
  contactForm = new FormGroup({
    name: new FormControl('', Validators.required),
		email: new FormControl('', [Validators.required, Validators.email,
      Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
    phone: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$"),Validators.minLength(10)]),
    message: new FormControl('', Validators.required)
	});

  ngOnInit(): void {
    // if (localStorage.getItem('userLoginData') !='') {
    //   this.router.navigateByUrl('/assigned'); 
    // }
    
    this.getIPAddress();
  }
  open(content: any) {
    this.modalService.open(content, { centered: true, size: 'sm' });
  }
  getIPAddress()
  {  
    this.http.get("https://jsonip.com/").subscribe((res:any)=>{
      //console.log(res.ip);
      return res.ip;
    },
    (error)=>{
     // console.log(error);
    });
    
  }
// convenience getter for easy access to form fields
get f() { return this.contactForm.controls; }
	
contactUs(contactForm:any)
{
  this.submitted = true;
 
  if(this.contactForm.invalid) { return; }
  this.auth.contact(this.contactForm.value).subscribe(
    (data)=>{
      console.log(data.success);
      if(data.success == true){
        this.router.navigateByUrl('/'); 
      }
      
    },(error) => { alert(error)  },
  );
  }
}

